import type { TFunction } from "i18next";

import { OperatorValue } from "@/config/operatorConfig";

export type OperatorPhrase = {
  text: string;
  isNegated: boolean;
};

export const getOperatorPhrase = (
  t: TFunction,
  operator: OperatorValue,
  isInverted: boolean,
): OperatorPhrase => {
  const included = t(`admin.segments.builder.operatorPhrase.${operator}`);
  if (!isInverted) return { text: included, isNegated: false };
  const excluded = t(
    `admin.segments.builder.operatorPhraseExcluded.${operator}`,
    { defaultValue: "" },
  );
  return excluded
    ? { text: excluded, isNegated: true }
    : { text: included, isNegated: false };
};

const upperFirst = (text: string): string =>
  text.charAt(0).toUpperCase() + text.slice(1);

export const getOperatorLabel = (
  t: TFunction,
  operator: OperatorValue,
  isInverted: boolean,
): OperatorPhrase => {
  const phrase = getOperatorPhrase(t, operator, isInverted);
  return { ...phrase, text: upperFirst(phrase.text) };
};
